import React, { useContext } from "react";
import "./css/buttons.css"
import LanguageContext from "../hooks/LanguageContext";
import { getText } from "../../utils/languageUtils";

const Dice = (props) => {
  const { language, translations: translationData } = useContext(LanguageContext);
  const translations = translationData?.snakeladder || {};
  return (
    <div>
      <button className="button roll-dice" type="button" onClick={props.diceValue} disabled={props.rolling ? true : false} style={{ backgroundColor: props.rolling ? "#c8c8c8" : "#792110", color: props.rolling ? "#454545" : "#ffffff" }}>{getText(translations.roll_the_dice, language)}</button>
    </div>
  )
}


export default Dice;
